@reference "../../styles/ui.css";

.items-per-page {
  @apply flex items-center shrink-0 text-gray-500;
}

.pagination-select {
  @apply text-sm;

  :global(.pagination-select__control) {
    min-height: 28px;
  }

  :global(.pagination-select__indicator) {
    padding-bottom: 0;
    padding-top: 0;

    :global(.pagination-select__indicator-separator) {
      margin: 0.25rem 0;
    }

    :global(.pagination-select__indicator svg) {
      height: 1rem;
      width: 1rem;
    }
  }

  :global(.pagination-select__input-container) {
    padding-bottom: 0;
    padding-top: 0;
  }
}
